/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { CountryVoResourceService } from '@well/common-libs/country-management/shell-api';
import { unitMeasurementSelectableResourceProviders } from '@well/common-libs/unit-measurement/data-access';
import {
  AccountVoResourceService,
  AgentZoneVoResourceService,
  CustomerContactsDropdownResourceService,
  DeliveryServiceProviderResourceService,
  DeliveryServiceVoResourceService,
  DelTerritoryVoResourceService,
  DriverVoResourceService,
  EmployeeVoResourceService,
  VehicleVoResourceService,
} from '@well/resource-services';

// TODO: split this list per app — these resources are not all needed in every app
// (e.g. driver/vehicle/territory are delivery-specific). Each app should register
// only the providers it actually uses, instead of pulling the whole bundle.
export const coreSelectableResourceProviders = [
  { provide: SelectableResourceService, useClass: DriverVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: CustomerContactsDropdownResourceService, multi: true },
  { provide: SelectableResourceService, useClass: VehicleVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: DeliveryServiceVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: EmployeeVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: AccountVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: AgentZoneVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: CountryVoResourceService, multi: true },
  { provide: SelectableResourceService, useClass: DeliveryServiceProviderResourceService, multi: true },
  { provide: SelectableResourceService, useClass: DelTerritoryVoResourceService, multi: true },
  ...unitMeasurementSelectableResourceProviders,
];
